module.exports = __webpack_public_path__ + "img/225-2ae809.png";